import React from "react";
import Template from "./NewsletterSteps/Template";

const Newsletter = () => {
   return (
      <>
         <Template />
      </>
   );
};

export default Newsletter;
